<template>
  <div class="header">
    <div class="header-logo">
      <div v-if="cainiao_logo">
        <img :src="logo_image" alt="Logo" />
      </div>
      <div v-if="qnp_logo">
        <img :src="qnp_logo_img" alt="Logo" />
      </div>
      <div class="box_head" v-if="ruyi_logo">
        <img :src="ruyi_logo_img" alt="Logo" />
        <!-- <div style="margin-top: -72px; margin-left: 75px">{{ siteName }}</div> -->
      </div>
      <div class="box_head" v-if="ty_logo">
        <img :src="ty_logo_img" alt="Logo" />
        <div style="margin-left: 5px;">{{ siteName }}</div>
      </div>
    </div>
    <div class="header-nav">
      <!-- 导航链接 -->
      <el-menu
        class="topmenu"
        :default-active="activeMenu"
        mode="horizontal"
        router
        active-text-color="blue"
      >
        <el-menu-item index="/"> 首页 </el-menu-item>
        <el-menu-item index="/zzc">中转仓</el-menu-item>
        <el-menu-item index="/syncOrder" exact-active-class="active">同步单</el-menu-item>
        <el-menu-item index="/lipinorder"> 礼品单</el-menu-item>
        <el-menu-item index="/cwmx">财务明细 </el-menu-item>
        <el-menu-item index="/dltg">代理推广 </el-menu-item>
      </el-menu>
    </div>
    <div class="header-user">
      <span v-if="isLogin">{{ user_grade }}</span>
      <div>
        <i
          v-if="isLogin"
          class="el-icon-user"
          style="
            border: #555 solid 1px;
            border-radius: 1em;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            padding: 5px;
            margin-right: 3px;
          "
        ></i>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right" v-if="isLogin"></i>
          </span>
          <el-dropdown-menu slot="dropdown" v-if="isLogin">
            <!-- <el-dropdown-item command="editInfo">修改信息</el-dropdown-item> -->
            <el-dropdown-item command="bind">拍单账号关联设置</el-dropdown-item>
            <!-- <el-dropdown-item command="wllog">绑定下单轨迹日志</el-dropdown-item> -->
            <el-dropdown-item command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <span v-if="!isLogin" @click="login()">登录 &nbsp;&nbsp;&nbsp;</span>
      <span v-if="!isLogin" @click="register()">注册</span>
      <span v-if="isLogin">
        <img :src="rmb_image" class="rmb_img" />{{ user_balance }}
      </span>
      <el-button v-if="isLogin" class="czcss" @click="recharge()">充值</el-button>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import "@/assets/custom-theme/index.css";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";

export default {
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  data() {
    return {
      isShow: false,
      nbisShow: false,
      userName: "",
      user_balance: 0.0,

      userToken: Cookies.get("view_userToken"),
      isLogin: false,
      rmb_image: require("@/assets/rmb.png"),
      logo_image: require("@/assets/cnyc_logo.png"),
      routerName: "",
      cainiao_logo: false,
      siteName: "",
      ruyi_logo_img: require("@/assets/ruyi_logo.png"),
      ruyi_logo: false,
      qnp_logo: false,
      qnp_logo_img: require("@/assets/qnp_logo.png"),
      ty_logo: false,
      ty_logo_img: require("@/assets/cnyc_logo2.png"),
      user_grade: "",
      gradeList: {
        1: "零售价",
        2: "一级会员",
        3: "二级会员",
        4: "三级会员",
        5: "四级会员",
        6: "五级会员",
        7: "六级代理",
        8: "内部代理",
        9: "内部专供",
        10: "大客户专用",
        11: "内部客户专用",
      },
    };
  },
  computed: {
    // 我们使用计算属性来获取到当前点击的菜单的路由路径，然后设置default-active中的值
    // 使得菜单在载入时就能对应高亮
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // 可以在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      this.routerName = this.$route.name;
      if (path.includes("/syncOrder")) {
        return "/syncOrder";
      } else if (path.includes("/cwmx")) {
        return "/cwmx";
      } else if (path.includes("/dltg")) {
        return "/dltg";
      } else if (path.includes("/zzc")) {
        return "/zzc";
      }
      // this.routerName = this.$route.name;
      return path;
    },
  },
  async created() {
    // 获取系统信息并设置logo
    const systemInfo = await this.$root.getSystemInfo();
    if (systemInfo && systemInfo.site_name) {
      this.setLogoBySiteName(systemInfo.site_name);
    }
    
    // 判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");
    if (userToken != undefined) {
      const token = Cookies.get("view_userToken");
      const url = this.$root.commonPreUrl + "/index/getUserInfo";
      const res1 = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      res1
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const resData = resd.data;
            Cookies.set("view_userType", "");
            const userType = resData.user_type;
            if (userType == 3 || userType == "3") {
              Cookies.set("view_userType", "admin", { expires: 1 });
            } else if (userType == 2 || userType == "2") {
              Cookies.set("view_userType", "sub", { expires: 1 });
            }

            Cookies.set("view_userId", resData.id, { expires: 1 });
            Cookies.set("view_userName", resData.name, { expires: 1 });
            Cookies.set("view_userBalance", resData.user_balance, { expires: 1 });
            Cookies.set("view_grade", resData.grade, { expires: 1 });
            Cookies.set("view_sendName", resData.send_name, { expires: 1 });
            Cookies.set("view_sendTel", resData.send_tel, { expires: 1 });

            this.userName = resData.name;
            this.user_balance = resData.user_balance;
            this.user_grade = this.gradeList[resData.grade];
          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
            this.$router.push("/login");
          }
          // this.$router.push("/");
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });

      this.isLogin = true;
    }
  },
  methods: {
    setLogoBySiteName(siteName) {
      // 先重置所有logo标志
      this.cainiao_logo = false;
      this.qnp_logo = false;
      this.ruyi_logo = false;
      this.ty_logo = false;
      
      const sn = siteName || Cookies.get("view_site_name");
      if (sn == "菜鸟云仓" || sn == "菜鸟云仓test") {
        this.cainiao_logo = true;
      } else if (sn == "全能拍云仓") {
        this.qnp_logo = true;
      } else if (sn == "如意云仓") {
        this.ruyi_logo = true;
      } else if (sn && sn != "undefined" && sn != "null") {
        this.ty_logo = true;
        this.siteName = sn;
      }
    },
    login() {
      this.$router.push({ path: "/login" });
    },
    logout() {
      // 重新导航到登录页面
      localStorage.clear();
      this.$root.removeCookies();
      this.$router.push({ path: "/login" });
    },
    register() {
      this.$router.push({ path: "/register" });
    },
    handleCommand(command) {
      if (command === "logout") {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
      } else if (command === "bind") {
        // 跳到绑定页面
        this.$router.push({ path: "/syncOrder/bind" });
      } else if (command == "wllog") {
        this.$router.push({ path: "/cwmx/wllog" });
      }
    },
    recharge() {
      this.$router.push({ path: "/cwmx/czzx" });
    },
    updateUserInfo() {},
  },
};
</script>

<style scoped>
  .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* .header-logo {
  height: 60px;
} */
.header-logo {
  display: flex;
  align-items: center; /* 垂直居中 */
  height: 60px;
}

.header-logo img {
  height: 50px; /* 调整logo图片高度 */
  display: block;
}
.header-nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.header-nav li {
  display: inline;
  margin-right: 10px; /* 根据需要调整间距 */
}
.el-menu--horizontal {
  border-bottom: none;
}
.header-user {
  color: black;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  /* margin-top: -4.5vh; */
  cursor: pointer;
}
.czcss {
  color: white;
  height: 30px;
  width: 50px;
  background-color: #0850fc;
  padding: 2px;
  /* margin-left: 7px; */
  cursor: pointer;
}

.topmenu {
  /* width: 55vw; */
  color: #838383;
  /* margin-top: -6vh; 
  margin-left: 15vw;*/
  font-weight: bold;
  background-color: white;
}
.rmb_img {
  height: 18px;
  width: 18px;
  display: inline-block;
  vertical-align: text-top;
  margin-right: 3px;
}
.topmenu .el-menu-item {
  font-size: 15px;
  font-weight: bold;
  color: rgb(126, 126, 126);
}
.box_head {
  /* padding-top: 10px;
  padding-bottom: 4px; */
  font-size: 36px;
  font-weight: bold;
  display: flex;
  align-items: center; 
}
.el-dropdown-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/topmenu/TopMenu.vue